export default "__VITE_ASSET__vjz0BJpa__"